module.exports = __webpack_public_path__ + "static/media/icn_ongoing_trtmnt_covid_fisdom.de01f36f.svg";